// ユーザー向けメッセージ
export const SUCCESS_MESSAGES = {
  // ログイン関連
  1000: 'ログインしました',
  // 登録関連
  1100: '登録が完了しました。',
  1101: 'メールアドレスの確認が完了しました。',
  1102: '更新が完了しました。',
}

// ユーザー向けエラーメッセージ
// 404 → 44XX
export const ERROR_MESSAGES = {
  // 400 Bad Request: 登録関連
  4000: '登録に失敗しました。',
  4001: '不正なURLです。',
  4002: 'URLの有効期限が切れています。再度登録を行ってください。',
  4003: '更新に失敗しました',
  4004: '不正なリクエストです。',
  4005: '不正なデータです',

  // 401 Unauthorized: ログイン関連
  4100: 'ログインに失敗しました。メールアドレスかパスワードが間違っています。',
  4101: 'ログインできませんでした。',
  4102: 'LINE連携がキャンセルされました。',
  4103: 'LINEログインできませんでした。ブラウザのCookie設定をご確認の上、再度お試しください。',

  // 404 Not Found
  4400: 'ページが見つかりませんでした。',

  // 500 Server Error
  5000: '予期しないエラーが発生しました。時間をおいて、やり直してください。',
  5001: 'メール送信に失敗しました。時間をおいて、やり直してください。',
  5002: 'LINEログインに失敗しました。時間をおいて、やり直してください。',
  5003: 'ユーザーが見つかりません。',
  5004: 'イベントが見つかりません。',
  5005: '既に申し込み済みです。',
  5006: 'このイベントは満員となっています。',
  5007: 'イベントは終了しています。',
  5009: 'イベントはまだ公開されていません。',
  5010: 'イベントはまだ申し込みが開始されていません。',
  5011: 'イベントの申し込みは終了しています。',
  5012: 'このイベントは受付期間外です。',
  5013: 'セッションは既に開始されています。',
  5014: '予期せぬエラーが発生しました。リンクの有効期限は1時間となっています。ログイン後にマイページから再度認証用リンクを送信してください。',
}

// 管理画面用 成功メッセージ
export const SUCCESS_MESSAGES_ADMIN = {
  // ログイン関連
  10000: 'ログインしました',
  // 登録関連
  10010: '保存が完了しました。',
  10020: 'メールアドレスの確認が完了しました。',

  // 更新関連
  10100: '削除が完了しました。',
}

// 管理画面用 エラーメッセージ
export const ERROR_MESSAGES_ADMIN = {
  // 400 Bad Request
  40000: '不正なリクエストです。',
  40001: '許可されていない操作です。',

  // 401 Unauthorized: ログイン関連
  40100: '認証に失敗しました。',
  40101: 'メールアドレスが間違っています。',
  40102: 'パスワードが間違っています。',

  // 403 Forbidden: 登録関連
  40200: '登録に失敗しました。',
  40201: '不正なURLです。',
  40202: '招待URLの有効期限が切れています。再度招待URLを発行してください。',
  40900: '既に登録済みのメールアドレスです。',

  // 404 Not Found
  44000: 'ページが見つかりませんでした。',
  44001: 'イベントが見つかりませんでした。',
  44002: '企業が見つかりませんでした。',
  44003: 'エントリーが見つかりませんでした。',
  44004: 'エントリーが抽選ではありません。',
  44005: 'このイベントタグ名は既に存在しています',
  44006: 'この流入経路名は既に存在しています',
  44007: 'この業界・業種名は既に存在しています',

  // 500 Server Error
  50000: '保存できませんでした。管理者にお問い合わせください。',
  50001: '保存できませんでした。時間をおいて、やり直してください。',
  50010: '予期しないエラーが発生しました。時間をおいて、やり直してください。',
  50011: '予期しないエラーが発生しました。管理者にお問い合わせください。',
}

export const VALIDATION_MESSAGES = {
  // 全体エラー
  INVALID_MESSAGE: 'エラーがあります。入力項目を確認してください。',

  EMPTY_ID: 'IDは必須です',
  INVALID_ID: 'IDの形式が正しくありません',
  INVALID_INPUT: '入力エラーがあります。入力を確認してください。',
  // メール
  EMPTY_EMAIL: 'メールアドレスを入力してください',
  INVALID_EMAIL: 'メールアドレスの形式が正しくありません',
  MAX_LENGTH_EMAIL: 'メールアドレスは1024文字以内で入力してください',
  UN_MATCH_EMAIL: 'メールアドレスが一致しません',

  // パスワード
  EMPTY_PASSWORD: 'パスワードを入力してください',
  MIN_LENGTH_PASSWORD: 'パスワードは8文字以上で入力してください',
  MAX_LENGTH_PASSWORD: 'パスワードは64文字以内で入力してください',
  CHARACTER_PASSWORD:
    'パスワードは英大文字・英小文字・数字が含まれる必要があります',
  // パスワード（確認）
  EMPTY_PASSWORD_CONFIRMATION: 'パスワード（確認）を入力してください',
  MIN_LENGTH_PASSWORD_CONFIRMATION:
    'パスワード（確認）は8文字以上で入力してください',
  MAX_LENGTH_PASSWORD_CONFIRMATION:
    'パスワード（確認）は64文字以内で入力してください',
  CHARACTER_PASSWORD_CONFIRMATION:
    'パスワード（確認）は英大文字・英小文字・数字が含まれる必要があります',
  UN_MATCH_PASSWORD: 'パスワードが一致しません',

  // パスワードリセット用トークン
  EMPTY_RESET_TOKEN: 'トークンが見つかりません',
  INVALID_RESET_TOKEN: 'トークンの形式が正しくありません',

  // ユーザー名
  EMPTY_FAMILY_NAME: '姓を入力してください',
  MAX_LENGTH_FAMILY_NAME: '姓は100文字以内で入力してください',
  EMPTY_GIVEN_NAME: '名を入力してください',
  MAX_LENGTH_GIVEN_NAME: '名は100文字以内で入力してください',
  // ユーザー名（フリガナ）
  EMPTY_FAMILY_NAME_KANA: 'セイ（フリガナ）を入力してください',
  MAX_FAMILY_NAME_KANA: 'セイ（フリガナ）は100文字以内で入力してください',
  KANA_ONLY_FAMILY_NAME_KANA: 'セイ（フリガナ）は全角カナで入力してください',
  EMPTY_GIVEN_NAME_KANA: 'メイ（フリガナ）を入力してください',
  MAX_GIVEN_NAME_KANA: 'メイ（フリガナ）は100文字以内で入力してください',
  KANA_ONLY_GIVEN_NAME_KANA: 'メイ（フリガナ）は全角カナで入力してください',

  // 性別
  EMPTY_SEX: '性別を選択してください',

  // 生年月日
  EMPTY_BIRTH_YEAR: '生年月日(年)を選択してください',
  EMPTY_BIRTH_MONTH: '生年月日(月)を選択してください',
  EMPTY_BIRTH_DAY: '生年月日(日)を選択してください',

  // 電話番号
  EMPTY_TEL: '電話番号を入力してください',
  ONLY_NUM_TEL: '電話番号は数字のみで入力してください',
  MAX_LENGTH_TEL: '電話番号は11桁の以内で入力してください',
  PHONE_LENGTH_TEL: '電話番号は11桁の携帯電話の番号を入力してください',

  // 住所
  EMPTY_POSTAL_CODE: '郵便番号を入力してください',
  ONLY_NUM_POSTAL_CODE: '郵便番号は数字のみで入力してください',
  MAX_LENGTH_POSTAL_CODE: '郵便番号は7文字で入力してください',

  EMPTY_PREFECTURE: '都道府県を選択してください',

  EMPTY_CITY: '市区郡・地名・番地を入力してください',
  MAX_LENGTH_CITY: '市区郡・地名・番地は200文字以内で入力してください',

  MAX_LENGTH_BUILDING_NAME: '建物名は200文字以内で入力してください',

  // 最終学歴
  EMPTY_ACADEMIC_BACKGROUND: '最終学歴を選択してください',
  // 大学名
  EMPTY_UNIVERSITY: '大学名を入力してください',
  MAX_LENGTH_UNIVERSITY: '大学名は100文字以内で入力してください',
  // 学部
  EMPTY_FACULTY: '学部名を入力してください',
  MAX_LENGTH_FACULTY: '学部名は100文字以内で入力してください',
  // 学科
  EMPTY_DEPARTMENT: '学科名を入力してください',
  MAX_LENGTH_DEPARTMENT: '学科名は100文字以内で入力してください',

  // 大学院名
  EMPTY_GRADUATE_NAME: '大学院名を入力してください',
  MAX_LENGTH_GRADUATE_NAME: '大学院名は100文字以内で入力してください',
  // 大学院の学部
  EMPTY_GRADUATE_FACULTY_NAME: '大学院の学部名を入力してください',
  MAX_LENGTH_GRADUATE_FACULTY_NAME:
    '大学院の学部名は100文字以内で入力してください',
  // 大学院の学科
  EMPTY_GRADUATE_DEPARTMENT_NAME: '大学院の学科名を入力してください',
  MAX_LENGTH_GRADUATE_DEPARTMENT_NAME:
    '大学院の学科名は100文字以内で入力してください',

  // 大学の都道府県
  EMPTY_UNIVERSITY_PREFECTURE: '大学の都道府県を選択してください',

  // 卒業年度
  EMPTY_GRADUATE_YEAR: '卒業年度(年)を選択してください',
  EMPTY_GRADUATE_MONTH: '卒業年度(月)を選択してください',

  // 理系・文系
  EMPTY_ACADEMIC_TRACK: 'どちらかを選択してください',

  // キャンセル理由
  MAX_LENGTH_CANCEL_REASON: 'キャンセル理由は1000文字以内で入力してください',
}

export const VALIDATION_MESSAGES_ADMIN = {
  // カルーセル
  EMPTY_CAROUSEL_ID: 'カルーセルIDは必須です',
  EMPTY_CAROUSEL_TITLE: 'タイトルを入力してください',
  INVALID_CAROUSEL_TITLE: 'タイトルの形式が正しくありません',
  MAX_LENGTH_CAROUSEL_TITLE: 'タイトルは50文字以内で入力してください',
  EMPTY_CAROUSEL_URL: 'URLを入力してください',
  INVALID_CAROUSEL_URL: 'URLの形式が正しくありません',
  EMPTY_CAROUSEL_IMAGE: '画像を選択してください',
  INVALID_CAROUSEL_IMAGE: '画像の形式が正しくありません',
  MAX_LENGTH_FEATURED_CAROUSEL: 'カルーセルは6件までです',

  // 記事
  EMPTY_ARTICLE_ID: '記事IDは必須です',
  EMPTY_ARTICLE_TITLE: 'タイトルを入力してください',
  INVALID_ARTICLE_TITLE: 'タイトルの形式が正しくありません',
  MAX_LENGTH_ARTICLE_TITLE: 'タイトルは50文字以内で入力してください',
  EMPTY_ARTICLE_URL: 'URLを入力してください',
  INVALID_ARTICLE_URL: 'URLの形式が正しくありません',
  EMPTY_ARTICLE_IMAGE: '画像を選択してください',
  INVALID_ARTICLE_IMAGE: '画像の形式が正しくありません',
  FIXED_LENGTH_FEATURED_ARTICLE: '注目の記事は8件固定です',

  // 企業
  EMPTY_COMPANY_ID: '企業IDは必須です',
  EMPTY_COMPANY_NAME: '企業名を入力してください',
  EMPTY_COMPANY_LOGO_IMAGE: '企業ロゴ画像を選択してください',
  EMPTY_COMPANY_PUBLISH_START: '公開日時を入力してください',
  COMPANY_PUBLISH_END_DATE_BEFORE_START_DATE:
    '公開日時より終了日時が同時刻もしくは前になっています。',
  EMPTY_COMPANY_LAST_MODIFIED_AT: '最終更新日を入力してください',
  FIXED_LENGTH_FEATURED_COMPANY: '注目の企業は6件固定です',
  EMPTY_INDUSTRY_ID: '業界・業種IDは必須です',
  EMPTY_COMPANY_INDUSTRIES: '業界・業種を選択してください',
  EMPTY_COMPANY_INTRODUCTION: '企業紹介を入力してください',
  EMPTY_COMPANY_DESCRIPTION: '企業説明を入力してください',
  EMPTY_COMPANY_BUSINESS_CONTENT: '事業内容を入力してください',
  EMPTY_COMPANY_FOUNDED_ON: '設立年月を入力してください',
  EMPTY_COMPANY_CAPITAL: '資本金を入力してください',
  EMPTY_COMPANY_CEO: '代表者を入力してください',
  EMPTY_COMPANY_ADDRESS: '本社所在地を入力してください',
  EMPTY_COMPANY_JOB_DESCRIPTION_INITIAL_LORE:
    '募集職種・仕事内容の雇入れ直後の項目を入力してください',
  EMPTY_COMPANY_JOB_DESCRIPTION_CHANGE_SCOPE:
    '募集職種・仕事内容の変更の範囲を入力してください',
  EMPTY_COMPANY_HR_MESSAGE: '人事からのメッセージを入力してください',
  EMPTY_COMPANY_ENTRY_FLOW: '採用の流れを入力してください',
  EMPTY_COMPANY_MIN_TOTAL_SALARY:
    '支給額の下限を0よりも大きい値で入力してください',
  EMPTY_COMPANY_MAX_TOTAL_SALARY:
    '支給額の上限を0よりも大きい値で入力してください',
  MAX_TOTAL_SALARY_IS_LARGER_THAN_MIN_TOTAL_SALARY:
    '支給額の下限と同じかそれよりも大きい値を入力してください',
  EMPTY_COMPANY_MIN_BASIC_SALARY:
    '基本給の下限を0よりも大きい値で入力してください',
  EMPTY_COMPANY_MAX_BASIC_SALARY:
    '基本給の上限を0よりも大きい値で入力してください',
  MAX_BASIC_SALARY_IS_LARGER_THAN_MIN_BASIC_SALARY:
    '基本給の下限と同じかそれよりも大きい値を入力してください',
  EMPTY_COMPANY_FIXED_OVERTIME_ALLOWANCE: '固定残業手当を入力してください',
  EMPTY_COMPANY_BONUS: '昇給・賞与を入力してください',
  EMPTY_COMPANY_WORK_PLACE_INITIAL_ROLE:
    '勤務地の雇入れ直後の項目を入力してください',
  EMPTY_COMPANY_WORK_PLACE_CHANGE_SCOPE: '勤務地の変更の範囲を入力してください',
  EMPTY_COMPANY_WORK_TIME: '勤務時間を入力してください',
  EMPTY_COMPANY_AVERAGE_OVERTIME: '平均残業時間を0以上の数値で入力してください',
  EMPTY_COMPANY_HOLIDAY: '休日・休暇を入力してください',
  EMPTY_COMPANY_ALLOWANCES: '諸手当を入力してください',
  EMPTY_COMPANY_WELFARE: '福利厚生を入力してください',
  EMPTY_COMPANY_TRAINING: '教育・研修制度を入力してください',
  EMPTY_COMPANY_OPEN_POSITIONS_COUNT: '採用予定人数を入力してください',
  EMPTY_COMPANY_HIRING_HISTORY: '過去採用実績を入力してください',
  EMPTY_COMPANY_HIRING_MANAGER:
    '採用担当者様の氏名・電話番号を入力してください',
  EMPTY_COMPANY_APPLICATION_PERIOD: '求人受付期間を入力してください',
  EMPTY_COMPANY_PASSIVE_SMOKING_POLICY_FACILITY:
    '就業場所における受動喫煙防止措置を選択してください',
  EMPTY_COMPANY_EMPLOYMENT_TYPE: '雇用区分を選択してください',
  EMPTY_COMPANY_TRIAL_PERIOD_SELECTION: '試用期間の有無を選択してください',
  EMPTY_COMPANY_TRIAL_PERIOD: '試用期間を1以上の数値で入力してください',
  EMPTY_COMPANY_CONTRACT_PERIOD_SELECTION: '期間の定めの有無を選択してください',
  EMPTY_COMPANY_APPLICATION_REQUIREMENTS: '応募資格を入力してください',
  EMPTY_INDUSTRY_NAME: '業界・業種名を入力してください',
  MAX_LENGTH_INDUSTRY_NAME: '業界・業種名は30文字以内で入力してください',

  // イベント
  EMPTY_INPUT: '入力は必須です。',
  OPEN_BEFORE_END: '開催日時より終了日時が同時刻もしくは前になっています。',
  START_BEFORE_CLOSE:
    'エントリー開始日時より終了日時が同時刻もしくは前になっています。',
  SESSION_START_BEFORE_CLOSE:
    'イベント開始日時より終了日時が同時刻もしくは前になっています。',
  SESSION_APPLICATION_END_AFTER_START:
    'イベント開始日時より応募締切終了日時が後になっています',
  FIXED_LENGTH_FEATURED_EVENTS: '注目のイベントは8件固定です',
  MIN_LENGTH_CAPACITY: '定員数は1以上で入力してください',
  GREATER_THAN_CURRENT_ENTRY_COUNT:
    '現在のイベント申込数より大きい値を入力してください',

  // ユーザー
  EMPTY_USER_NAME: 'ユーザー名を入力してください',
  EMPTY_USER_ID: 'ユーザーが存在しません',

  // タグ
  EMPTY_TAG_ID: 'イベントタグIDは必須です',
  EMPTY_TAG_NAME: 'イベントタグ名を入力してください',
  MAX_LENGTH_TAG_NAME: 'イベントタグ名は20文字以内で入力してください',

  // 流入経路
  EMPTY_TRAFFIC_SOURCE_ID: '流入経路IDは必須です',
  EMPTY_TRAFFIC_SOURCE_NAME: '流入経路名を入力してください',
  MAX_LENGTH_TRAFFIC_SOURCE_NAME: '流入経路名は100文字以内で入力してください',

  // 管理画面代理登録用
  MAX_LENGTH_TRAFFIC_SOURCE_LABEL:
    '流入経路ラベルは100文字以下で入力してください',
  // メール
  EMPTY_EMAIL: 'メールアドレスを入力してください',
  INVALID_EMAIL: 'メールアドレスの形式が正しくありません',
  MAX_LENGTH_EMAIL: 'メールアドレスは1024文字以内で入力してください',
  // ユーザー名
  EMPTY_FAMILY_NAME: '姓を入力してください',
  MAX_LENGTH_FAMILY_NAME: '姓は100文字以内で入力してください',
  EMPTY_GIVEN_NAME: '名を入力してください',
  MAX_LENGTH_GIVEN_NAME: '名は100文字以内で入力してください',
  // ユーザー名（フリガナ）
  EMPTY_FAMILY_NAME_KANA: 'セイ（フリガナ）を入力してください',
  MAX_LENGTH_FAMILY_NAME_KANA:
    'セイ（フリガナ）は100文字以内で入力してください',
  KANA_ONLY_FAMILY_NAME_KANA: 'セイ（フリガナ）は全角カナで入力してください',
  EMPTY_GIVEN_NAME_KANA: 'メイ（フリガナ）を入力してください',
  MAX_LENGTH_GIVEN_NAME_KANA: 'メイ（フリガナ）は100文字以内で入力してください',
  KANA_ONLY_GIVEN_NAME_KANA: 'メイ（フリガナ）は全角カナで入力してください',
  // 生年月日
  INVALID_BIRTH_YEAR: '1900年から2030年の間で有効な年を選択してください',
  INVALID_BIRTH_MONTH: '1月から12月の間で有効な月を選択してください',
  INVALID_BIRTH_DAY: '1日から31日の間で有効な日を選択してください',
  // 電話番号
  EMPTY_TEL: '電話番号を入力してください',
  PHONE_NUMBER_FORMAT: '電話番号は11桁の携帯電話の番号を入力してください',
  // 最終学歴
  EMPTY_ACADEMIC_BACKGROUND: '最終学歴を選択してください',
  // 大学名
  EMPTY_UNIVERSITY: '大学名を入力してください',
  MAX_LENGTH_UNIVERSITY: '大学名は100文字以内で入力してください',
  // 学部
  EMPTY_FACULTY: '学部名を入力してください',
  MAX_LENGTH_FACULTY: '学部名は100文字以内で入力してください',
  // 学科
  EMPTY_DEPARTMENT: '学科名を入力してください',
  MAX_LENGTH_DEPARTMENT: '学科名は100文字以内で入力してください',
  // 大学院名
  EMPTY_GRADUATE: '大学院名を入力してください',
  MAX_LENGTH_GRADUATE: '大学院名は100文字以内で入力してください',
  // 大学院の学部
  EMPTY_GRADUATE_FACULTY: '大学院の学部名を入力してください',
  MAX_LENGTH_GRADUATE_FACULTY: '大学院の学部名は100文字以内で入力してください',
  // 大学院の学科
  EMPTY_GRADUATE_DEPARTMENT: '大学院の学科名を入力してください',
  MAX_LENGTH_GRADUATE_DEPARTMENT:
    '大学院の学科名は100文字以内で入力してください',
  // 卒業年度
  EMPTY_GRADUATE_YEAR: '卒業年度(年)を選択してください',
  INVALID_GRADUATE_YEAR: '1900年から2040年の間で有効な卒業年を選択してください',
  EMPTY_GRADUATE_MONTH: '卒業年度(月)を選択してください',
  INVALID_GRADUATE_MONTH: '1月から12月の間で有効な卒業月を選択してください',
}
